import axios from "axios";

const base = `${process.env.REACT_APP_BACKEND_URL}/funding`;
const token = () => localStorage.getItem("token");
const headers = () => ({ headers: { Authorization: "Bearer " + token() } });

export const getMeta = () => axios.get(`${base}/meta`, headers());
export const getRules = () => axios.get(`${base}/rules`, headers());
export const saveRules = rules => axios.put(`${base}/rules`, { rules }, headers());
export const resetRules = () => axios.delete(`${base}/rules`, headers());
export const estimate = body => axios.post(`${base}/estimate`, body, headers());
export const listCases = filters => axios.post(`${base}/list`, filters, headers());
export const createCase = body => axios.post(base, body, headers());
export const getCase = id => axios.get(`${base}/${id}`, headers());
export const updateCase = (id, body) => axios.put(`${base}/${id}`, body, headers());
export const deleteCase = id => axios.delete(`${base}/${id}`, headers());
export const changeStatus = (id, body) => axios.post(`${base}/${id}/status`, body, headers());
export const getSources = id => axios.get(`${base}/${id}/sources`, headers());
export const importCosts = (id, body) => axios.post(`${base}/${id}/costs/import`, body, headers());
export const updateChecklist = (id, key, body) =>
  axios.put(`${base}/${id}/checklist/${encodeURIComponent(key)}`, body, headers());
export const addDeadline = (id, body) => axios.post(`${base}/${id}/deadlines`, body, headers());
export const updateDeadline = (id, deadlineId, body) =>
  axios.put(`${base}/${id}/deadlines/${deadlineId}`, body, headers());
export const deleteDeadline = (id, deadlineId) =>
  axios.delete(`${base}/${id}/deadlines/${deadlineId}`, headers());
export const getClause = (id, params) =>
  axios.get(`${base}/${id}/clause`, { ...headers(), params });
export const insertClause = (id, body) => axios.post(`${base}/${id}/clause/offer`, body, headers());
export const archiveDocument = (id, kind) =>
  axios.post(`${base}/${id}/documents/${kind}`, {}, headers());

// Links that open in a new tab cannot send a header: the token goes in the query.
export const documentUrl = (id, kind) =>
  `${base}/${id}/documents/${kind}/pdf?token=${encodeURIComponent(token() || "")}`;
export const archivedUrl = (id, docId) =>
  `${base}/${id}/files/${docId}?token=${encodeURIComponent(token() || "")}`;
